import script from "./PromptTuningQueue.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptTuningQueue.vue?vue&type=script&setup=true&lang=js"

import "./PromptTuningQueue.vue?vue&type=style&index=0&id=47d35784&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d35784"]])

export default __exports__